import { useEffect, useRef } from "react";
import Button from "../button/Button";
import PaginationComponent from "../pagnationComponent";
import LoadingSpinner from "../spinner";
import Can from "../../../utils/can";
import ErrorMessage from "../messages/errorMessage";

import { IoAdd, IoAddSharp } from "react-icons/io5";
import AddIcon from "../../Common/svg/addicon";
import EmptyList from "../messages/emptyList";
import { FileMinus } from "react-feather";
import DeleteIcon from "../../Common/svg/deleteicon";
const DataTable = ({
  title,
  columns,
  data = [],
  actionLabel,
  onAddClick,
  isLoading,
  totalItems,
  currentPage,
  setCurrentPage,
  itemsPerPage,
  isFetching,
  createPermission,
  error,
  onRetry,
  excel,
  importExcel,
  exportExcel,
  handleFileChange,
  fileInputRef,
  isPending,
  isBulkDelete,
  deleteSelectedProducts,
  actionButtons = [],
}) => {
  const isInitialLoad = useRef(true);

  useEffect(() => {
    if (!isLoading) {
      isInitialLoad.current = false;
    }
  }, [isLoading]);
  const getValue = (obj, path) => {
    return path.split(".").reduce((acc, part) => acc && acc[part], obj);
  };

  // Check for error state first
  if (error) {
    return (
      <div className="bg-white p-3 mt-6 overflow-x-auto rounded-4 position-relative custom-table mb-3">
        <div className="d-flex w-100 justify-content-between align-items-center mb-3">
          {title && <h3 className="font16 title">{title}</h3>}
          {actionLabel && (
            <Can permission={createPermission}>
              <Button
                variant="primary"
                label={actionLabel}
                onClick={onAddClick}
                icon={<AddIcon />}
              >
                {actionLabel}
              </Button>
            </Can>
          )}
        </div>
        <div style={{ minHeight: "200px" }}>
          <ErrorMessage
            message={
              error?.response?.data?.message || "حدث خطأ أثناء جلب البيانات"
            }
            details={error?.message || "يرجي إعادة المحاولة"}
            onRetry={onRetry}
          />
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white p-3 mt-6 overflow-x-auto rounded-4 position-relative custom-table mb-3">
      <div className="d-flex w-100 justify-content-between align-items-center mb-3">
        {title && <h3 className="font16 title">{title}</h3>}
        <div className="d-flex gap-2">
          {isBulkDelete && (
            <Button
              variant="danger"
              label={"حذف العناصر المحددة"}
              onClick={() => deleteSelectedProducts()}
            >
              {" "}
            </Button>
          )}

          {excel && (
            <Can permission={createPermission}>
              <Button
                variant="primary"
                label={isPending ? "جاري الاستيراد..." : "استيراد Excel"}
                disabled={isPending}
                onClick={() => importExcel()}
                icon={<FileMinus />}
              >
                {isPending ? "جاري الاستيراد..." : actionLabel}
              </Button>
              <input
                type="file"
                accept=".xlsx,.xls"
                ref={fileInputRef}
                style={{ display: "none" }}
                onChange={handleFileChange}
              />
            </Can>
          )}
          {excel && (
            <Can permission={createPermission}>
              <Button
                variant="primary"
                label={"تصدير Excel"}
                onClick={() => exportExcel()}
                icon={<FileMinus />}
              >
                {actionLabel}
              </Button>
            </Can>
          )}
  {actionButtons.length > 0
    ? actionButtons.map((btn, index) => (
        <Can
          key={index}
          permission={btn.permission || createPermission}
        >
          <Button
            variant={btn.variant || "primary"}
            label={btn.label}
            onClick={btn.onClick}
            icon={btn.icon || <AddIcon />}
          >
            {btn.label}
          </Button>
        </Can>
      ))
    : actionLabel && (
        <Can permission={createPermission}>
          <Button
            variant="primary"
            label={actionLabel}
            onClick={onAddClick}
            icon={<AddIcon />}
          >
            {actionLabel}
          </Button>
        </Can>
      )}
        </div>
      </div>
      {isFetching && !isInitialLoad.current && <LoadingSpinner />}
      <table className="min-w-full text-sm  text-right w-100">
        <thead className="bg-gray-100 text-gray-700">
          <tr>
            {columns.map((col, i) => (
              <th key={i} className="p-2">
                {col.label}
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          {isInitialLoad.current && isLoading ? (
            Array.from({ length: 5 }).map((_, rowIndex) => (
              <tr key={rowIndex} className="">
                {columns.map((col, colIndex) => (
                  <td key={colIndex} className=" p-2 font800 table-row ">
                    <div className="skeleton" />
                  </td>
                ))}
              </tr>
            ))
          ) : data.length === 0 ? (
            <tr>
              <td
                colSpan={columns.length}
                className="text-center py-4 text-muted"
              >
                <EmptyList />
              </td>
            </tr>
          ) : (
            data.map((row, i) => (
              <tr key={i} className="custom-border-bottom">
                {columns.map((col, j) => (
                  <td key={j} className="p-2">
                    {col.render ? col.render(row) : getValue(row, col.accessor)}
                  </td>
                ))}
              </tr>
            ))
          )}
        </tbody>
      </table>

      {totalItems ? (
        <PaginationComponent
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          totalItems={totalItems}
          itemsPerPage={itemsPerPage}
        />
      ) : null}
    </div>
  );
};

export default DataTable;
